import { PopupType } from '../../../components/popup/types';
import { Logger } from '../../../logger/Logger';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import type { GameCommunicationMessageType } from '../types';
import { MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

interface DealerMessage extends GameCommunicationMessageType {
  id?: string;
  value?: string;
}

export class CoreDealerGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.Dealer;

  public process(message: DealerMessage): void {
    if (message.value) {
      this.store.dispatch(
        gameStateActions.setDealer({
          id: message?.id ?? null,
          name: message.value,
        })
      );

      if (message.value.toUpperCase() === 'NO DEALER') {
        this.store.dispatch(popupActions.pushPopup(PopupType.TableClosed));
        this.store.dispatch(gameStateActions.setGamePaused(true));
      } else {
        this.store.dispatch(popupActions.dismissPopup(PopupType.TableClosed));
        this.store.dispatch(gameStateActions.setGamePaused(false));
      }
    } else {
      Logger.logFailure('dealerName', {
        additional: 'invalid',
      });
    }
  }
}
